(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedresourcescarouselblock = window.oneadvanced.refreshedresourcescarouselblock || {};
    window.oneadvanced.refreshedresourcescarouselblock.init = function () {
        //console.log("initialising refreshedresourcescarouselblock...");
        var refreshedResourcesCarousels = document.querySelectorAll('[data-refreshedresourcescarousel-block-id]');
        if (refreshedResourcesCarousels.length) {
            for (var rrc = 0; rrc < refreshedResourcesCarousels.length; rrc++) {
                refreshedResourcesCarouselHandler(
                    refreshedResourcesCarousels[rrc].getAttribute('data-refreshedresourcescarousel-block-id')
                );
            }
        }
        function refreshedResourcesCarouselHandler(blockId) {
            // from here: https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8

            // breakpoint where swiper will be destroyed
            // and switches to a row layout
            var breakpoint = window.matchMedia('(min-width:1025px)');
            // keep track of swiper instances to destroy later
            var mySwiper;

            var resizeCardInternals = function () {
                //console.log("setting card internal heights.");
                var allResourceCardTitles = document.querySelectorAll('.refreshedresourcecardblock__title');
                var cardMaxHeight = 0;

                allResourceCardTitles.forEach((card) => {
                    if (card.offsetHeight > cardMaxHeight) {
                        cardMaxHeight = card.offsetHeight;
                    }
                });

                allResourceCardTitles.forEach((card) => {
                    card.style.height = `${cardMaxHeight}px`;
                });
            };

            var breakpointChecker = function () {
                // if larger viewport and multi-row layout needed
                if (breakpoint.matches === true) {
                    // clean up old instances and inline styles when available
                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    // or/and do nothing
                    resizeCardInternals();
                    return;
                    // else if a small viewport and single column layout needed
                } else if (breakpoint.matches === false) {
                    // fire small viewport version of swiper
                    return enableSwiper();
                }
            };

            var nextButton = document.getElementById('resSwiperNext');
            var prevButton = document.getElementById('resSwiperPrev');

            var enableSwiper = function () {
                mySwiper = new Swiper('[data-refreshedresourcescarousel-block-id="' + blockId + '"]', {
                    direction: 'horizontal',
                    loop: false,
                    slidesPerView: 'auto',
                    initialSlide: 0,
                    grabCursor: true,
                    breakpoints: {
                        // when window width is >= 320px Mobile 
                        320: {
                            slidesPerView: 1,
                            centeredSlides: true,
                        },
                    },
                });
                resizeCardInternals();
            };

            // keep an eye on viewport size changes
            breakpoint.addListener(breakpointChecker);
            // kickstart
            breakpointChecker();

            nextButton?.addEventListener('click', (evt) => {
                evt.preventDefault();

                if (mySwiper.isBeginning) {
                    prevButton?.classList.remove('invisible');
                }

                mySwiper.slideNext();
            });

            prevButton?.addEventListener('click', (evt) => {
                evt.preventDefault();

                mySwiper.slidePrev();
            });
        }
    };
    window.oneadvanced.refreshedresourcescarouselblock.hasLoaded = true;
})();